import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { customElement, property } from 'lit/decorators.js'
import { LitElement } from 'lit'
import { getAntConfig } from '../../app-core/lib/ant-overrides/ant-config'
import { ConfigProvider } from 'antd'
import { type FlowChange, ReportStatusFlowSettings } from '../../app-core/lib/reportStatus/ReportStatusFlowSettings'
import type { SupportedLanguage } from '../i18n/types.no-deps'

type componentProps = React.ComponentProps<typeof ReportStatusFlowSettings>

@customElement('zaptic-report-statuses')
export class ReportStatusesWrapper extends LitElement {
    @property({ type: Object })
    props: componentProps

    @property()
    language: SupportedLanguage = 'en-GB'

    private onFlowChanged(flowChange: FlowChange) {
        this.dispatchEvent(
            new CustomEvent<FlowChange>('on-change', {
                detail: flowChange,
            })
        )
    }

    render() {
        return ReactDOM.render(
            <ConfigProvider {...getAntConfig()}>
                <ReportStatusFlowSettings
                    statuses={this.props.statuses}
                    flow={this.props.flow}
                    onChange={(newFlow) => this.onFlowChanged(newFlow)}
                    showValidationErrors={this.props.showValidationErrors}
                    allUsers={this.props.allUsers}
                    allTeams={this.props.allTeams}
                    featureFlags={this.props.featureFlags}
                />
            </ConfigProvider>,
            this
        )
    }

    protected createRenderRoot() {
        return this
    }
}
